import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import alertify from "alertifyjs";
import { SuccessDialogComponent } from 'src/app/Shared/shared/success-dialog/success-dialog.component';
import { ConfirmDialogComponent } from 'src/app/Shared/shared/confirm-dialog/confirm-dialog.component';
import { ErrorDialogComponent } from 'src/app/Shared/shared/error-dialog/error-dialog.component';

@Component({
  selector: 'app-reconcile-mda-bils-manual',
  templateUrl: './reconcile-mda-bils-manual.component.html',
  styleUrls: ['./reconcile-mda-bils-manual.component.css']
})
export class ReconcileMdaBilsManualComponent {

  @Output() onConfirmClicked = new EventEmitter();
  @Input() paymentDetails: any;
  @Input() bill: any


    isSaving: boolean = false;

    constructor(
       
        private apiService: ApiServiceService,
        private bsModalRef: BsModalRef,
        private bsModalService: BsModalService,
    ) {
  
    }
  
    ngOnInit(): void {
     
  
    
    }
  
  
    save(){
    
      this.isSaving = true;
  
  
      const url = `/assessments/mda/manual-reconciliation/${this.paymentDetails?.paymentId}/${this.bill?.id}`;
  
      this.apiService.post(url, {}).subscribe(
        (response) => {
          this.isSaving = false
  
         if(response?.message =='MDA bill updated successfully'){
  
          this.confirmAfterSuccess(response.message);
            alertify.set("notifier", "position", "top-center");
            alertify.success("Payment has been successfully updated");
  
         }else{
          
            this.confirmAfterError(response?.message);
          
         }
  
        },
        (error) => {
          this.isSaving = false
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
  
          this.confirmAfterError("Error performing this operation")
         
        },
      );
  
    
  
    }
  
    confirmAfterSuccess(message: any) {
      let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
        initialState: {
          body: message,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        dfModalRef.hide();
      });
    }
  
    confirmSave(){
  
        let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
          initialState: {
            body: "Proceed to save update",
          },
          class: "modal-sm modal-dialog-centered",
        });
        dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.save()
          dfModalRef.hide();
        });
      
  
    }
  
  
   
  
    close() {
      this.onConfirmClicked.emit();
      this.bsModalRef.hide();
    }
  
    
    confirmAfterError(message: any) {
      let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
        initialState: {
          body: message,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        dfModalRef.hide();
      });
    }
  
  
  
  }
  